export default __webpack_public_path__ + "static/media/tourIcon.b9a20239.svg";